module.exports = __webpack_public_path__ + "img/Feature.8f28e512.png";